import { render, staticRenderFns } from "./cancel-appoint.vue?vue&type=template&id=682620b4&scoped=true&"
import script from "./cancel-appoint.vue?vue&type=script&lang=js&"
export * from "./cancel-appoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682620b4",
  null
  
)

export default component.exports